module.exports = __webpack_public_path__ + "img/tile-tel1.86a070c0.png";